import { CustomerInfo, EntitlementInfo } from "@revenuecat/purchases-js";
import User from "../../../shared/data/user/User";

import offerings from "./offerings.json";

// Compatibilité React Native
const Puchases = undefined;
export { Puchases };

export const initInAppPurchaseSDK = async () => {

}

export type SubscriptionDiscount = {
    readonly identifier: string;
    readonly price: number;
    readonly priceString: string;
    readonly cycles: number;
    readonly period: string;
    readonly periodUnit: string;
    readonly periodNumberOfUnits: number;
}

export type SubscriptionPrice = {
    price: number,
    priceString: string,
    periodNumberOfUnits: number,
    period: string,
    cycles: number,
    periodUnit: string
}

export declare enum PRODUCT_CATEGORY {
    NON_SUBSCRIPTION = "NON_SUBSCRIPTION",
    SUBSCRIPTION = "SUBSCRIPTION",
    UNKNOWN = "UNKNOWN"
}
export declare enum PRODUCT_TYPE {
    CONSUMABLE = "CONSUMABLE",
    NON_CONSUMABLE = "NON_CONSUMABLE",
    NON_RENEWABLE_SUBSCRIPTION = "NON_RENEWABLE_SUBSCRIPTION",
    AUTO_RENEWABLE_SUBSCRIPTION = "AUTO_RENEWABLE_SUBSCRIPTION",
    PREPAID_SUBSCRIPTION = "PREPAID_SUBSCRIPTION",
    UNKNOWN = "UNKNOWN"
}

export type SubscriptionProduct = {
    title: string,
    introPrice: SubscriptionPrice | null,
    discounts: SubscriptionDiscount[] | null,
    productType: PRODUCT_TYPE,
    description: string,
    identifier: string,
    productCategory: PRODUCT_CATEGORY | null,
    price: number,
    currencyCode: string,
    priceString: string
}

export declare enum PACKAGE_TYPE {
    UNKNOWN = "UNKNOWN",
    CUSTOM = "CUSTOM",
    LIFETIME = "LIFETIME",
    ANNUAL = "ANNUAL",
    SIX_MONTH = "SIX_MONTH",
    THREE_MONTH = "THREE_MONTH",
    TWO_MONTH = "TWO_MONTH",
    MONTHLY = "MONTHLY",
    WEEKLY = "WEEKLY"
}

export const numberOfMonthsByPackageType = {
    ANNUAL: 12,
    SIX_MONTH: 6,
    THREE_MONTH: 3,
    TWO_MONTH: 2,
    MONTHLY: 1
}

export type SubscriptionPackage = {
    packageType: PACKAGE_TYPE,
    product: SubscriptionProduct,
    offeringIdentifier: string,
    identifier: string
}

export const restorePurchase = async (email: string) => {
    
}

export const getOfferings = async () => {
    try {
        const user: User = User.getInstance();
        let subscriptionsPackage: SubscriptionPackage[] = [];
        let offeringPackages = [];
        let reductions: any = {};
        let higherPriceByMonth: { packageType: PACKAGE_TYPE | undefined, price: number } = {
            packageType: undefined,
            price: -1
        };
        if (offerings !== null) {
            if (user.profile === "teacher") {
                if ((offerings.all !== undefined) && (offerings.all.LASV2 !== undefined)) {
                    offeringPackages = offerings.all.LASV2.availablePackages;
                }
            } else if (user.profile === "family") {
                if ((offerings.all !== undefined) && (offerings.all.LAHV2 !== undefined)) {
                    offeringPackages = offerings.all.LAHV2.availablePackages;
                }
            }
        }
        // TODO : REDISCTRIUER LES PACKAGES "PUCHASES" DANS DES PACKAGES "LILI"
        for (const anOfferingIndex in offeringPackages) {
            if (Object.prototype.hasOwnProperty.call(offeringPackages, anOfferingIndex)) {
                const aPackage = offeringPackages[anOfferingIndex];
                if (aPackage.packageType === "MONTHLY") {
                    if (aPackage.product.price > higherPriceByMonth.price) {
                        higherPriceByMonth = {
                            price: aPackage.product.price,
                            packageType: aPackage.packageType
                        }
                    }
                } else if (aPackage.packageType === "THREE_MONTH") {
                    const priceByMonth: number = aPackage.product.price / 3;
                    if (priceByMonth > higherPriceByMonth.price) {
                        higherPriceByMonth = {
                            price: priceByMonth,
                            packageType: aPackage.packageType
                        }
                    }
                }
                subscriptionsPackage.push(aPackage);
            }
        }
        for (const anOfferingIndex in offeringPackages) {
            if (Object.prototype.hasOwnProperty.call(offeringPackages, anOfferingIndex)) {
                const aPackage = offeringPackages[anOfferingIndex];
                if (numberOfMonthsByPackageType[aPackage.packageType] !== undefined) {
                    let reduction: number = 0;
                    let priceByMonth: number = aPackage.product.price / numberOfMonthsByPackageType[aPackage.packageType];
                    if (higherPriceByMonth.price > priceByMonth) {
                        reduction = (1 - (priceByMonth / higherPriceByMonth.price)) * 100;
                        reductions[aPackage.packageType] = Math.floor(reduction);
                    }
                }

            }
        }
        // On va maintenant comparer les packages avec le prix le plus élevé pour avoir la réduction de chacun
        return {
            package: subscriptionsPackage,
            reductions
        }
    } catch (error) {
    }
}

export const treatPurchaserInfo = (purchaserInfo: CustomerInfo) => {
    if (purchaserInfo !== undefined) {
        if (purchaserInfo.entitlements !== undefined) {
            if (purchaserInfo.entitlements.active !== undefined) {
                let activeSub = {};
                let isSub = false;
                for (const anEntitlementsKey in purchaserInfo.entitlements.active) {
                    if (Object.prototype.hasOwnProperty.call(purchaserInfo.entitlements.active, anEntitlementsKey)) {
                        const element: EntitlementInfo = purchaserInfo.entitlements.active[anEntitlementsKey];
                        const purchaseDateAsDate = new Date(element.latestPurchaseDate);
                        const purchaseDateAsMillis = purchaseDateAsDate.getTime();
                        if (anEntitlementsKey === "LAS") {
                            const now = new Date().getTime();
                            if (element.expirationDate !== null) {
                                const expirationDateAsDate = new Date(element.expirationDate);
                                const expirationDateAsMillis = expirationDateAsDate.getTime();
                                if (expirationDateAsMillis > now) {
                                    activeSub = {
                                        creationDate: purchaseDateAsMillis,
                                        date: purchaseDateAsMillis,
                                        expires_date: expirationDateAsMillis,
                                        origin: element.store,
                                        product_id: element.productIdentifier,
                                        start_date: purchaseDateAsMillis,
                                        auto_renewing: element.willRenew
                                    };
                                    isSub = true;
                                    break;
                                }
                            } else {
                                let numberOfMonthTheAdd = 3;
                                if ((element.productIdentifier === "cool.lili.sub.laspremiumtwelve") || (element.productIdentifier === "cool.lili.subnr.laspremiumtwelve")) {
                                    numberOfMonthTheAdd = 12;
                                }
                                const expirationDate = new Date(purchaseDateAsDate.setMonth(purchaseDateAsDate.getMonth() + numberOfMonthTheAdd));
                                if (expirationDate.getTime() > now) {
                                    activeSub = {
                                        creationDate: purchaseDateAsMillis,
                                        date: purchaseDateAsMillis,
                                        expires_date: expirationDate.getTime(),
                                        origin: element.store,
                                        product_id: element.productIdentifier,
                                        start_date: purchaseDateAsMillis,
                                        auto_renewing: element.willRenew
                                    };
                                    isSub = true;
                                    break;
                                }
                            }
                        } else if (anEntitlementsKey === "Premium") {
                            const now = new Date().getTime();
                            if (element.expirationDate !== null) {
                                const expirationDateAsDate = new Date(element.expirationDate);
                                const expirationDateAsMillis = expirationDateAsDate.getTime();
                                if (expirationDateAsMillis > now) {
                                    activeSub = {
                                        creationDate: purchaseDateAsMillis,
                                        date: purchaseDateAsMillis,
                                        expires_date: expirationDateAsMillis,
                                        origin: element.store,
                                        product_id: element.productIdentifier,
                                        start_date: purchaseDateAsMillis,
                                        auto_renewing: element.willRenew
                                    };
                                    isSub = true;
                                    break;
                                }
                            }
                        } else if (anEntitlementsKey === "Gift") {
                            const now = new Date().getTime();
                            const giftDuration = {
                                "cool.lili.gift.twelvemonths": 12,
                                "cool.lili.gift.elevenmonths": 11,
                                "cool.lili.gift.tenmonths": 10,
                                "cool.lili.gift.ninemonths": 9,
                                "cool.lili.gift.heightmonths": 8,
                                "cool.lili.gift.sevenmonths": 7,
                                "cool.lili.gift.sixmonths": 6,
                                "cool.lili.gift.fivemonths": 5,
                                "cool.lili.gift.fourmonths": 4,
                                "cool.lili.gift.threemonths": 3,
                                "cool.lili.gift.twomonths": 2,
                                "cool.lili.gift.onemonth": 1,
                            }
                            let numberOfMonthTheAdd = giftDuration[element.productIdentifier] ?? 1;
                            const expirationDate = new Date(purchaseDateAsDate.setMonth(purchaseDateAsDate.getMonth() + numberOfMonthTheAdd));
                            if (expirationDate.getTime() > now) {
                                activeSub = {
                                    creationDate: purchaseDateAsMillis,
                                    date: purchaseDateAsMillis,
                                    expires_date: expirationDate.getTime(),
                                    origin: element.store,
                                    product_id: element.productIdentifier,
                                    start_date: purchaseDateAsMillis,
                                    auto_renewing: element.willRenew
                                };
                                isSub = true;
                                break;
                            }
                        }
                    }
                }
                if (isSub === true) {
                    return activeSub;
                } else {
                    // On va faire un test sur les nonSubscriptionTransaction
                    if ((purchaserInfo.nonSubscriptionTransactions !== undefined) && (purchaserInfo.nonSubscriptionTransactions !== null) && (purchaserInfo.nonSubscriptionTransactions.length > 0)) {
                        for (const aTransaction of purchaserInfo.nonSubscriptionTransactions) {
                            const dateOfPurchase: number = new Date(aTransaction.purchaseDate).getTime();
                            let expirationDate: Date = new Date(dateOfPurchase);
                            const currentTime: number = new Date().getTime();
                            let oneYearProduct: string[] = ["prod_NFIeOjG3QzrO7X", "prod_OAHZNzq7WkXvhw"];
                            if (oneYearProduct.indexOf(aTransaction.productIdentifier) !== -1) {
                                expirationDate = new Date(expirationDate.getFullYear()+1, expirationDate.getMonth(), expirationDate.getDay(), expirationDate.getUTCHours(), expirationDate.getUTCMinutes());
                            } else {
                                expirationDate = new Date(expirationDate.getFullYear(), expirationDate.getMonth()+3, expirationDate.getDay(), expirationDate.getUTCHours(), expirationDate.getUTCMinutes());
                            }
                            if (expirationDate.getTime() > currentTime) {
                                activeSub = {
                                    creationDate: dateOfPurchase,
                                    date: dateOfPurchase,
                                    expires_date: expirationDate.getTime(),
                                    origin: "STRIPE",
                                    product_id: aTransaction.productIdentifier,
                                    start_date: dateOfPurchase,
                                    auto_renewing: false
                                };
                                isSub = true;
                                break;
                            }
                        }
                        if (isSub === true) {
                            return activeSub;
                        }
                    }
                    return null;
                }
            } else {
                return null;
            }
        } else {
            return null;
        }
    } else {
        return null;
    }
}

export const getPurchaserInfo = async () => {

}